<template>
  <!-- Transaction -->
  <div class="modal fade language-translate" id="translate-language">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div class="progress-language">
            <div class="percentage-progress">
              <div class="language-blk">
                <h2 class="table-avatar language-avatar">
                  <a
                    href="javascript:;"
                    data-bs-toggle="modal"
                    data-bs-target="#translate-language"
                    ><img
                      class="avatar-img rounded-circle me-2"
                      src="@/assets/admin_img/flag/flag-02.png"
                      alt="User Image"
                    />Arabic</a
                  >
                </h2>
              </div>
              <div class="track-statistics mb-0">
                <span>Progress</span>
                <div class="d-flex align-items-center">
                  <div class="progress mb-0">
                    <div
                      class="progress-bar bg-info progress-bar"
                      role="progressbar"
                      style="width: 90%"
                      aria-valuenow="90"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <div class="statistic-head">
                    <p>90%</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <router-link
                to="/admin-template/language"
                @click="redirectReload"
                class="refine-filter back-transaction"
                ><span><i class="bx bx-arrow-back me-1"></i></span>Back to Translations
              </router-link>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <div class="table-responsive">
              <table class="table table-hover table-center mb-0">
                <thead>
                  <tr>
                    <th>English</th>
                    <th>Arabic</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="record in LanguageTranslate" :key="record.id">
                    <td>{{ record.Name }}</td>
                    <td>
                      <div class="pass-login mb-0">
                        <input type="text" class="form-control" :value="record.Value" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Submit
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Transaction -->

  <!-- Transaction -->
  <div class="modal fade" id="add-transaction">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Transalation</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label"
                      >Languages <span class="dark-red">*</span></label
                    >
                    <input type="text" class="form-control" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">Code <span class="dark-red">*</span></label>
                    <input type="text" class="form-control" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Submit
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Transaction -->

  <!-- Transaction -->
  <div class="modal fade" id="edit-transaction">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Transalation</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="user-profiles-group mb-4">
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label"
                      >Languages <span class="dark-red">*</span></label
                    >
                    <input type="text" class="form-control" value="Arabic" />
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="pass-login">
                    <label class="form-label">Code <span class="dark-red">*</span></label>
                    <input type="text" class="form-control" value="435" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="mute-chat-btn">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Submit
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Transaction -->

  <!-- Delete User -->
  <div class="modal fade" id="delete-user">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete Language</h5>
          <button type="button" class="close" data-bs-dismiss="modal" :aria-label="$t('close')">
            <span class="material-icons">close</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <div class="block-user-blk">
            <p>Deleting entire Language from this device</p>
          </div>
          <div class="mute-chat-btn justify-content-center">
            <a class="btn btn-primary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Continue
            </a>
            <a class="btn btn-secondary" data-bs-dismiss="modal" :aria-label="$t('close')">
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete User -->
</template>
<script>
import LanguageTranslate from "@/assets/json/admin/language-translate.json";
export default {
  data() {
    return {
      LanguageTranslate: LanguageTranslate,
    };
  },
  methods: {
    redirectReload() {
      this.$router.push({ path: "/language" }).then(() => {
        this.$router.go();
      });
    },
  },
};
</script>
